import React from "react";

const CategoryWarningModal = ({ onClose }) => {
  return (
    <div className="category-warning-modal" onClick={onClose}>
      <div className="model-inner" onClick={(e) => e.stopPropagation()}>
        <h2>Warning</h2>
        <p>Please select a Category.</p>
        <div className="ok-btn">
          <button onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default CategoryWarningModal;
